import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('emons_daily_balance');
